import axiosInstance from "../Shared/Utils/axiosInstance";
import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";

export const getANMDetails = async (selectedLanguageId,selectedType) => {
  try {
    const response = await axiosInstance.get(
      `/api/anmDetailsTable?languageid=${selectedLanguageId}&typeData=${selectedType}`
    );
    return TokenDecrypt(response.data);
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch ASHA profile"
    );
  }
};

export const transferAnmMappingsService = async (subcenter, anm1id, anm2id) => {
  const response = await axiosInstance.put("/api/transferAnmMappings", {
    sc1: [subcenter],
    anm1id,
    anm2id,
  });

  return response.data;
};
